<template>
  <div class="upload_wrap">
    <!-- 图片上传组件辅助-->
    <div v-if="fileUrl.name" class="file_box" @click.stop="handleNone">
      <p style="margin: 0;">{{ fileUrl.name }}</p>
      <i v-if="!isDisabled" class="close_btn el-icon-error" @click.stop="closeFn" style="font-size: 20px; color: red"></i>
    </div>
    <template v-if="!isDisabled">
      <i v-if="quillUpdate" class="el-icon-loading avatar-uploader-icon" style="font-size: 25px; color: #999"></i>
      <el-upload class="avatar-uploader" :action="uploadUrl+action" name="file" :headers="header" :show-file-list="false" :on-success="uploadSuccess" :on-error="uploadError" :before-upload="beforeUpload" :disabled="quillUpdate" :accept="uploadFileAccept">
        <el-button v-if="fileUrl.id" size="small" type="primary">重新上传</el-button>
        <el-button v-if="!fileUrl.id" size="small" type="primary">点击上传</el-button>
      </el-upload>
    </template>
    <el-dialog title="视频预览" :visible.sync="filePreviewDialogVisible" width="50%" :before-close="closePreviewFileDialog">
      <div class="preview_wrap">
        <video ref="previewVideo" style="width: 500px;height: 400px;" autoplay controls :src="curPreviewFileUrl"></video>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closePreviewFileDialog">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Object,
      default() {
        return {
          id: '',
          name: '',
        }
      }
    },
    action: {
      type: String,
      default: "/upload/uploadToLocal",
    },
    uploadFileAccept: {
      type: String,
      default: '',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      curPreviewFileUrl: '',//视频附件url
      filePreviewDialogVisible: false,//附件预览弹框
      fileUrl: this.value,
      quillUpdate: false, // 根据图片上传状态来确定是否显示loading动画，刚开始是false,不显示
      header: {},// token: sessionStorage.getItem("token")
    };
  },
  watch: {
    value: function (val) {
      this.fileUrl = val;
    },
    fileUrl: function (val) {
      this.$emit("file-event", val);
    },
  },
  methods: {
    closeFn() {
      this.fileUrl = {
        id: '',
        name: '',
      };
    },
    // 关闭文件预览对话框
    closePreviewFileDialog() {
      this.filePreviewDialogVisible = false
      this.$refs.previewVideo.pause();
    },
    handleNone() {
      if (/\.(png|jpeg|jpg|gif|PNG|JPEG|JPG|GIF)$/.test(this.fileUrl.name)) {
        window.open(`${this.uploadUrl}/upload/previewImage/${this.fileUrl.id}`, '_blank')
      } else if (/\.(doc|docx|DOC|DOCX)$/.test(this.fileUrl.name)) {
        window.open(`${this.uploadUrl}/upload/downloadPdf/${this.fileUrl.id}`, '_blank')
      } else if (/\.(mp4|rm|rmvb|3gp|avi|mpeg|mpg|mkv|dat|asf|wmv|flv|mov|ogg|ogm|RM|RMVB|3GP|AVI|MPEG|MPG|MKV|DAT|ASF|WMV|FLV|MOV|MP4|OGG|OGM)$/.test(this.fileUrl.name)) {
        // window.open(`${this.uploadUrl}/upload/previewVideo/${this.fileUrl.id}`, '_blank')// 视频
        this.curPreviewFileUrl = `${this.uploadUrl}/upload/previewVideo/${this.fileUrl.id}`
        this.filePreviewDialogVisible = true
      } else if (/\.(pdf|PDF)$/.test(this.fileUrl.name)) {
        window.open(`${this.uploadUrl}/upload/previewPdf/${this.fileUrl.id}`, '_blank')
      } else {
        window.open(`${this.uploadUrl}/upload/download?id=${this.fileUrl.id}&openStyle=1`, '_blank')
      }
    },
    beforeUpload(file) {
      let isFileType = true;
      this.quillUpdate = true;
      if (!this.uploadFileAccept) {
        isFileType = file.type === 'application/msword' || file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        if (!isFileType) {
          this.$message.error('文档只能是 doc 或者 docx 格式!');
        }
      }
      if (!isFileType) { this.quillUpdate = false; }
      return isFileType;
    },
    uploadSuccess(res, file) {
      // this.fileUrl = URL.createObjectURL(file.raw);
      if (res.code == 200) {
        this.$message.success("上传成功", res, file);
        this.fileUrl = {
          id: res.data[0],
          name: file.name,
        }
      } else {
        this.$message.error("上传失败");
      }
      this.quillUpdate = false;
    },
    uploadError() {
      this.quillUpdate = false;
      this.$message.error("上传失败");
    },
  },
};
</script> 

<style scoped>
.preview_wrap {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.upload_wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
.file_box {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #d9d9d9;
  height: 30px;
  padding: 0 20px;
  cursor: pointer;
  /* max-width: calc(100% - 150px); */
  max-width: 70%;
}
.file_box p {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  /* max-width: 80%; */
}
.loading_icon {
  position: absolute;
}
.close_btn {
  position: absolute;
  top: -8px;
  right: -8px;
}
.upload_wrap >>> .avatar-uploader .el-upload {
  border-radius: 0;
  border: none;
  cursor: pointer;
  overflow: inherit;
  width: auto;
  height: 32px;
  max-width: 100%;
}
</style>